export default (list, item, propertyKey) => {
  const currentIndex = list.findIndex(listItem => listItem[propertyKey] === item[propertyKey]);
  const otherValues = list.filter(listItem => listItem[propertyKey] !== item[propertyKey]);
  const newValues = [...otherValues];

  newValues.splice(currentIndex, 0, item);

  return newValues;
};
